const API_ERRORS = {
    SURVEY_STAY_NOT_FOUND: { id: 1, name: 'SURVEY_STAY_NOT_FOUND', code: 60004, message: "Stay not found" },
    SURVEY_ALREADY_COMPLETED: { id: 2, name: 'SURVEY_ALREADY_COMPLETED', code: 60001, message: "Survey already completed" },
    SURVEY_NOT_FOUND: { id: 3, name: 'SURVEY_NOT_FOUND', code: 60002, message: "Survey not found" },
    UNKNOW_ERROR: { id: 4, name: 'UNKNOW_ERROR', code: 0, message: "Unknown error happened" },
    INVALID_SURVEY_REQUEST: { id: 5, name: 'INVALID_SURVEY_REQUEST', code: 60003, message: "Survey request missing parameters" }
};

export default API_ERRORS;